import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

let UiCNotificationsComponent = class UiCNotificationsComponent {
    constructor() {
        this.clickEvt = new EventEmitter();
    }
    ngOnInit() { }
    changeClass() {
        this.clickEvt.emit();
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCNotificationsComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCNotificationsComponent.prototype, "message", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCNotificationsComponent.prototype, "class", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCNotificationsComponent.prototype, "date", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCNotificationsComponent.prototype, "read", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCNotificationsComponent.prototype, "clickEvt", void 0);
UiCNotificationsComponent = __decorate([
    Component({
        selector: 'ui-c-notifications',
        template: "<div (click)=\"changeClass()\" class=\"notifications border ion-padding\">\n    <div [ngClass]=\"class\">\n        <ng-container>\n            <ion-row class=\"ion-title ion-justify-content-center\">\n                <ion-col size=\"10\" class=\"ion-align-items-start\">\n                    <ion-text class=\"ion-text ion-text-left\">\n                        <p class=\"ion-text font-family-bold font-size-16 ion-no-margin\">{{title}}</p>\n                    </ion-text>\n                </ion-col>\n            </ion-row>\n        </ng-container>\n\n        <ng-container>\n            <ion-row class=\"ion-justify-content-center\">\n                <ion-col size=\"10\" class=\"ion-align-items-start\">\n                    <ion-text class=\"ion-text ion-text-left\">\n                        <p class=\"ion-text font-size-12 ion-no-margin ion-sub\">{{message}}</p>\n                    </ion-text>\n                </ion-col>\n            </ion-row>\n        </ng-container>\n    </div>\n\n    <ng-container>\n        <ion-row class=\"ion-justify-content-center\">\n            <ion-col size=\"10\" class=\"ion-align-items-start\">\n                <ion-text class=\"ion-text ion-text-left\">\n                    <p class=\"ion-text font-size-12 ion-no-margin ion-sub-date\">{{date | date: 'dd/MM/yyyy'}}</p>\n                </ion-text>\n            </ion-col>\n        </ion-row>\n    </ng-container>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCNotificationsComponent);

let UiCNotificationsModule = class UiCNotificationsModule {
};
UiCNotificationsModule = __decorate([
    NgModule({
        declarations: [UiCNotificationsComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            IonicModule
        ],
        exports: [
            UiCNotificationsComponent
        ]
    })
], UiCNotificationsModule);

export { UiCNotificationsComponent, UiCNotificationsModule };
//# sourceMappingURL=wlp-ui-c-notifications.js.map
